import { jsx as _jsx } from "react/jsx-runtime";
import { useBreakpointsContext } from "@air/provider-media-query";
import { useMemo } from "react";
import BoardCrumbs from "~/components/Workspace/BoardHeader/BoardCrumbs";
import { ShortBoardCrumbs } from "~/components/Workspace/BoardHeader/BoardCrumbs/ShortBoardCrumbs";
export const ViewControlsBoardHeader = (param)=>{
    let { title, ancestors = [], onBoardClick } = param;
    const { isAboveXLScreen } = useBreakpointsContext();
    const ancestorsView = useMemo(()=>{
        if (isAboveXLScreen) {
            if (!ancestors.length) {
                return /*#__PURE__*/ _jsx("div", {
                    className: "truncate text-12 font-medium text-grey-11",
                    children: title
                });
            } else {
                return /*#__PURE__*/ _jsx(BoardCrumbs, {
                    ancestors: ancestors || [],
                    title: title,
                    onBoardClick: onBoardClick
                });
            }
        }
        return /*#__PURE__*/ _jsx(ShortBoardCrumbs, {
            ancestors: ancestors,
            title: title,
            onBoardClick: onBoardClick
        });
    }, [
        ancestors,
        isAboveXLScreen,
        onBoardClick,
        title
    ]);
    return /*#__PURE__*/ _jsx("div", {
        className: "flex",
        children: ancestorsView
    });
};
